import React from "react";

import { buttonStyles, cardStyles, colorPallete, textStyles } from "../styles";
import { isMobileOnly, isTablet, isElectron, isAndroid, isIOS, deviceDetect, deviceType, isIOS13, isBrowser } from 'react-device-detect';
import { APPID, APPVERSION, APPYEAR, APPDAY, DATE } from "./globals";

import LZString from 'lz-string';

import FormatQuoteIcon from '@material-ui/icons/FormatQuote';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import DevicesIcon from '@material-ui/icons/Devices';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import VideoLibrarySharpIcon from '@material-ui/icons/VideoLibrarySharp';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import AssessmentIcon from '@material-ui/icons/Assessment';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import OndemandVideoIcon from '@material-ui/icons/OndemandVideo';
import SpeakerIcon from '@material-ui/icons/Speaker';
import CodeIcon from '@material-ui/icons/Code';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
    faGraduationCap, faUniversity, faBook, faBookmark, 
    faHeadphones, faNewspaper, faTabletAlt, faVideo, faTablets,
    faHome, faCog, faUserMd, faPlay, faPlayCircle, faSitemap, faFireAlt,
    faStar, faFileAlt, faFile, faFileMedicalAlt, faTimes, faBox, faSquare, faPlus, faShare, faSearch, faInbox, faCalendarAlt, faFolderPlus, faCertificate, faBookMedical, faBalanceScale, faBalanceScaleLeft, faArrowUp, faUndo
} from '@fortawesome/free-solid-svg-icons'
import { trackPage } from "../actions";

import { 
    AUABarSolidIcon, AUABookOpenSolid, AUAChevronLeftSolid,
    AUAFrownRegular, AUAGraduationCapSolid, AUAHomeIcon, AUAMehIcon,
    AUAPodcast, AUAPhotoVideoIcon, AUAPlayCircle, AUASmile,
    AUATablet, AUAUniversityIcon, AUAUserMD, AUAYouTube
} from "../svg";

export const validCME = (cmeyear) => {
    let bool = false;

    let date = new Date();
    date.setMonth(date.getMonth() - 25);
    const year = date.getFullYear();

    if (cmeyear > year) {
        bool = true;
    }

    return bool;
}

export const hasLegal = () => {
    const thisday = Number(getLocalStorage('sasp_AILegalStatementDAY', `hasLegal`)) ? Number(getLocalStorage('sasp_AILegalStatementDAY', `hasLegal`)) : 0;

    const thisyear = Number(getLocalStorage('sasp_AILegalStatementYEAR', `hasLegal`)) ? Number(getLocalStorage('sasp_AILegalStatementYEAR', `hasLegal`)) : 0;

    let bool = false;

    if (APPYEAR() > thisyear) {
        bool = true;
    } else if (APPYEAR() === thisyear && APPDAY() > thisday) {
        bool = true;
    }

    return bool;
}

export const getAUAIcon = (icon) => {
    switch(icon) {
        case 'AUARefresh': {
            return <FontAwesomeIcon icon={faUndo} />; 
        }
        case 'AUALegal': {
            return <FontAwesomeIcon icon={faBalanceScale} />; 
        }
        case 'AUALegalLeft': {
            return <FontAwesomeIcon icon={faBalanceScaleLeft} />; 
        }
        case 'AUAHeadPhones': {
            return <FontAwesomeIcon icon={faHeadphones} />;
        }
        case 'AUATestingIcon': {
            return <FontAwesomeIcon icon={faFireAlt} />;
        }
        case 'AUANewsIcon': {
            return <FontAwesomeIcon icon={faNewspaper} />;
        }
        case 'CoursesIcon': {
            return <FontAwesomeIcon icon={faGraduationCap} />;
        }
        case 'CertificatesIcon': {
            return <FontAwesomeIcon icon={faUniversity} />;
        }
        case 'AUAFileIcon': {
            return <FontAwesomeIcon icon={faFileAlt} />;
        }
        case 'AUAMedicalFileIcon': {
            return <FontAwesomeIcon icon={faFileMedicalAlt} />;
        }
        case 'AUABarSolidIcon': {
            return <AUABarSolidIcon />
        }
        case 'AUABookOpenSolid': {
            return <AUABookOpenSolid />
        }
        case 'AUAChevronLeftSolid': {
            return <AUAChevronLeftSolid />
        }
        case 'AUAGraduationCapSolid': {
            return <AUAGraduationCapSolid />
        }
        case 'AUAHomeIcon': {
            return <AUAHomeIcon />
        }
        case 'AUAFrownIcon':
        case 'AUAFrownRegular': {
            return <AUAFrownRegular />
        }
        case 'AUAMehIcon': {
            return <AUAMehIcon />
        }
        case 'AUASmile':
        case 'AUASmileIcon': {
            return <AUASmile />
        }
        case 'AUAPodcast': {
            return <AUAPodcast />
        }
        case 'AUAPhotoVideoIcon': {
            return <AUAPhotoVideoIcon />
        }
        case 'AUAPlayCircle': {
            return <AUAPlayCircle />
        }
        case 'AUATablet': {
            return <AUATablet />
        }
        case 'AUAUniversityIcon': {
            return <AUAUniversityIcon />
        }
        case 'AUAUserMD': {
            return <AUAUserMD />
        }
        case 'AUAYouTube': {
            return <AUAYouTube />
        }
        case 'AUAGuidelines': {
            return <FontAwesomeIcon icon={faSitemap} />;
        }
        case 'BookMarksIcon': {
            return <FontAwesomeIcon icon={faBookmark} />;
        }
        case 'InboxIcon': {
            return <FontAwesomeIcon icon={faInbox} />;
        }
        case 'AnnualMeetingIcon': {
            return <FontAwesomeIcon icon={faCalendarAlt} />;
        }
        case 'SearchIcon': {
            return <FontAwesomeIcon icon={faSearch} />
        }
        case 'IPOCIcon': {
            // return <FontAwesomeIcon icon="fas faStar" />;
            return <FontAwesomeIcon icon={faCertificate} />;
        }
        case 'IPOCUnclaimedIcon': {
            return <FontAwesomeIcon icon={faBookMedical} />;
        }
        default: {
            return getIcon(icon);
        }
    }
}

export const getIcon = (icon, fontSize) => {
    if (typeof fontSize === 'undefined' || fontSize === null) { fontSize = "2.5em"; }
    switch(icon) {
        case 'AUAUpArrow': {
            return <FontAwesomeIcon icon={faArrowUp} />;
        }
        case 'IPOCIcon': {
            // return <FontAwesomeIcon icon="fas faStar" />;
            return <FontAwesomeIcon icon={faCertificate} />;
        }
        case 'IPOCUnclaimedIcon': {
            return <FontAwesomeIcon icon={faBookMedical} />;
        }
        case 'NewFolderIcon': {
            return <FontAwesomeIcon icon={faFolderPlus} />;
        }
        case 'InboxIcon': {
            return <FontAwesomeIcon icon={faInbox} />;
        }
        case 'SearchIcon': {
            return <FontAwesomeIcon icon={faSearch} />
        }
        case 'ShareIcon': {
            return <FontAwesomeIcon icon={faShare} />
        }
        case 'BookMarksIcon': {
            return <FontAwesomeIcon icon={faBookmark} />;
        }
        case 'CoursesIcon': {
            return <FontAwesomeIcon icon={faGraduationCap} />;
        }
        case 'AcceptIcon':
        case 'AddIcon': {
            return <FontAwesomeIcon icon={faPlus} />;
        }
        case 'CloseIcon':
        case 'CancelIcon': {
            return <FontAwesomeIcon icon={faTimes} />;
        }
        case 'CertificatesIcon': {
            return <FontAwesomeIcon icon={faUniversity} />;
        }
        case 'CoreCurriculumIcon':
        case 'seminalref': {
            return <FontAwesomeIcon icon={faBook} />;
        }
        case 'auaref': {
            return <FontAwesomeIcon icon={faStar} />;
        }
        case 'PodCastsIcon': 
        case 'AUAHeadPhones': {
            return <FontAwesomeIcon icon={faHeadphones} />;
        }
        case 'AUANewsIcon': 
        case 'GuideLinesIcon': {
            return <FontAwesomeIcon icon={faNewspaper} />;
        }
        case 'AppIcon':
        case 'UpdateSeriesIcon': {
            return <FontAwesomeIcon icon={faTabletAlt} />;
        }
        case 'CoreCurriculumVideosIcon': {
            return <FontAwesomeIcon icon={faVideo} />;
        }
        case 'PlayCircleIcon': {
            return <FontAwesomeIcon icon={faPlayCircle} />;
        }
        case 'PlayIcon': {
            return <FontAwesomeIcon icon={faPlay} />;
        }
        case 'SpeakerIcon': {
            return <SpeakerIcon style={{fontSize: fontSize}} />;
        }
        case 'FormatQuoteIcon': {
            return <FormatQuoteIcon style={{fontSize: fontSize}} />;
        }
        case 'LocalHospitalIcon': {
            return <LocalHospitalIcon style={{fontSize: fontSize}} />;
        }
        case 'QuestionAnswerIcon': {
            return <QuestionAnswerIcon style={{fontSize: fontSize}} />;
        }
        case 'DevicesIcon': {
            return <DevicesIcon style={{fontSize: fontSize}} />;
        }
        case 'LibraryBooksIcon': {
            return <LibraryBooksIcon style={{fontSize: fontSize}} />;
        }
        case 'VideoLibrarySharpIcon': {
            return <VideoLibrarySharpIcon style={{fontSize: fontSize}} />;
        }
        case 'VideoLibraryIcon': {
            return <VideoLibraryIcon style={{fontSize: fontSize}} />;
        }
        case 'AssessmentIcon': {
            return <AssessmentIcon style={{fontSize: fontSize}} />;
        }
        case 'PictureAsPdfIcon': {
            return <PictureAsPdfIcon style={{fontSize: fontSize}} />;
        }
        case 'OndemandVideoIcon': {
            return <OndemandVideoIcon style={{fontSize: fontSize}} />;
        }
        case 'CodeIcon': {
            return <CodeIcon style={{fontSize: fontSize}} />;
        }
        case 'HomeIcon': {
            return <FontAwesomeIcon icon={faHome} />;
            // return <HomeIcon style={{fontSize: fontSize}} />
        }
        case 'AccountCircleIcon': {
            return <FontAwesomeIcon icon={faUserMd} />;
            // return <AccountCircleIcon style={{fontSize: fontSize}} />
        }
        case 'SettingsIcon': {
            return <FontAwesomeIcon icon={faCog} />;
            // return <SettingsIcon style={{fontSize: fontSize}} />
        }
        default: {
            return null;
        }
    }
}

export const clearLocalStorage = () => {
    localStorage.removeItem('sasp-hideDaily');
    localStorage.removeItem('sasp-dailyEpoch');
    localStorage.removeItem('sasp-ratingEpoch');
    localStorage.removeItem('sasp-hideVersion');
    return false;
}

export const stylePicker = (type, category) => {
    const classes = styleCategory(category);
    switch (type) {
        case "primary":
            return classes.primary;
        case "secondaryBlue":
            return classes.secondaryBlue;
        case "secondaryGreen":
            return classes.secondaryGreen;
        case "neutralLight":
            return classes.neutralLight;
        case "neutralDark":
            return classes.neutralDark;
        case "neutralGreen":
            return classes.neutralGreen;
        case "accentGreen":
            return classes.accentGreen;
        case "accentAqua":
            return classes.accentAqua;
        case "accentBlue":
            return classes.accentBlue;
        case "accentRed":
            return classes.accentRed;
        case "accentOrange":
            return classes.accentOrange;
        case "accentYellow":
            return classes.accentYellow;
        case "questionButtons":
            return classes.questionButtons;
        case "dynamicButton":
            return classes.dynamicButton;
        case "trueQuestionButtons":
            return classes.trueQuestionButtons;
        default:
            return classes.primary;
    }
};

export const getPGY = (val) => {
    switch(val) {
        case 11:
        case '11': {
            return 'PGY1'
        }
        case 12:
        case '12': {
            return 'PGY2'
        }
        case 13:
        case '13': {
            return 'PGY3'
        }
        case 14:
        case '14': {
            return 'PGY4'
        }
        case 15:
        case '15': {
            return 'PGY5 (non-chief)'
        }
        case 16:
        case '16': {
            return 'PGY5/6 (chief)'
        }
        default: 
        return 'not a valid pgy level';
    }
}

export const logErr = () => {
};

export const colorPicker = color => {
    const colors = colorPallete();
    switch (color) {
        case "primary":
            return colors.primary;
        case "secondaryBlue":
            return colors.secondaryBlue;
        case "secondaryGreen":
            return colors.secondaryGreen;
        case "neutralLight":
            return colors.neutralLight;
        case "neutralDark":
            return colors.neutralDark;
        case "neutralGreenCard":
            return colors.neutralGreenCard;
        case "neutralGreen":
            return colors.neutralGreen;
        case "neutralBlue":
            return colors.neutralBlue;
        case "neutralBlueCard":
            return colors.neutralBlueCard;
        case "neutralBlueText":
            return colors.neutralBlueText;
        case "accentGreen":
            return colors.accentGreen;
        case "accentAqua":
            return colors.accentAqua;
        case "accentBlue":
            return colors.accentBlue;
        case "accentRed":
            return colors.accentRed;
        case "accentOrange":
            return colors.accentOrange;
        case "accentYellow":
            return colors.accentYellow;
        case "questionButtons":
            return colors.questionButtons;
        case "dynamicButton":
            return colors.dynamicButton;
        case "trueQuestionButtons":
            return colors.trueQuestionButtons;
        case "correctGradedButtons":
            return colors.correctGradedButtons;
        case "correctQuestionButtons":
            return colors.correctQuestionButtons;
        case "incorrectGradedButtons":
            return colors.incorrectGradedButtons;
        case "incorrectQuestionButtons":
            return colors.incorrectQuestionButtons;
        case "neutralLightCard":
            return colors.neutralLightCard
        case "neutralLightText":
            return colors.neutralLightText
        case "secondaryBlueCard":
            return colors.secondaryBlueCard
        case "secondaryBlueText":
            return colors.secondaryBlueText
        case "accentYellowCard":
            return colors.accentYellowCard
        case "accentYellowText":
            return colors.accentYellowText
        case "accentRedCard":
            return colors.accentRedCard
        case "accentRedText":
            return colors.accentRedText
        case "accentBlueCard":
            return colors.accentBlueCard
        case "accentBlueText":
                return colors.accentBlueText
        case "secondaryGreenText":
            return colors.secondaryGreenText
        case "secondaryGreenCard":
            return colors.secondaryGreenCard
        case "submitButtons":
            return colors.submitButtons
        default:
            return;
    }
};

const styleCategory = type => {
    switch (type) {
        case "button":
            return buttonStyles();
        case "deck":
            return cardStyles();
        case "text":
            return textStyles();
        default:
            return buttonStyles();
    }
};

export const textValidate = (text, type) => {
    if (type === "id") {
        return /^[0-9]{8}$/.test(text);
    }
    if (type === "email") {
        return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            text
        );
    }
    if (type === "password") {
        return /^[\w\s\W]{6,}$/.test(text);
    }
};

export const hashString = (string) => {
    let hash = 0, i, chr;
    if (string.length === 0) return hash;
    for (i = 0; i < string.length; i++) {
        chr     = string.charCodeAt(i);
        hash    = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

export const deviceData = (location, action) => {
    if (typeof action !== 'undefined') { action = 'navigate'; }
    let pageVia = 'SASP ' + deviceType + ' App';

    let _type = 'mobile';

    if (isTablet) { _type = 'tablet' } else if (isElectron) { _type = 'testing' }

    if (isAndroid) {
        pageVia = `SASP Android ${_type} App`;
    } else if (isIOS) {
        pageVia = `SASP iOS ${_type} App`;
    } else if (isElectron) {
        pageVia = `SASP Electron ${_type} App`;
    }

    let device = deviceDetect();

    let obj = {
        pathname : location.pathname,
        pagevia : pageVia,
        action : action,
        os : 'unknown',
        ua : 'unknown',
        appid: APPID,
        appversion: APPVERSION,
    };

    if (isElectron || isBrowser) {
        obj.os = device.osName + ' ' + device.osVersion;
        obj.ua = device.userAgent;

    } else if (isIOS) {
        obj.os = device.os + ' ' + device.model + ' ' + device.osVersion;
        obj.ua = device.ua;
    } else if (isAndroid) {
        obj.os = 'android';
        obj.ua = 'android';

        if (typeof device.os !== 'undefined' && typeof device.model !== 'undefined' && typeof device.osVersion !== 'undefined') {
            obj.os = device.os + ' ' + device.model + ' ' + device.osVersion;
        } else if (typeof device.osName !== 'undefined') {
            obj.os = device.osName + ' ' + device.osVersion;
        }

        if (typeof device.ua !== 'undefined') {
            obj.ua = device.ua;
        } else if (typeof device.userAgent !== 'undefined') {
            obj.ua = device.userAgent;
        }
    }

    return obj;
}

export const getSASPURI = (year) => {
    return 'https://auau.auanet.org/content/self-assessment-study-program-sasp-' + year;
}

export const getSASPFacultyURI = (year) => {
    return 'https://auau.auanet.org/content/self-assessment-study-program-sasp-' + year + '#group-tabs-node-course-default2';
}

export const getPastThreeYearsArr = () => {
    let arr = [];

    const d = new Date();
    const y = d.getFullYear();

    for (let i = 0; i < 3; i-- ) {
        arr.push(y - i);
    }

    return arr;
}

export const remoteURL = (uri) => {
    if (window.cordova) {
        if (window.cordova.InAppBrowser) {
            let type = '_system';
            return window.cordova.InAppBrowser.open(uri, type, 'location=yes');
        }          
    } else {
        return window.location.href = uri;
    }

    return null;
}

export const makeList = (arrs) => {
    let r = '';
    let c = 0;
    for (const index in arrs) {
        if (arrs[index]) {
            if (c > 0) {
                r += ',';
            }

            r += index;
            c++;
        }
    }
    return r;
}

export const scrollTop = (id, offset) => {
    if (typeof id === 'undefined') { id = 'root'; }
    if (typeof offset === 'undefined') { offset = 54; }

    let elem = document.getElementById(id);

    // console.log(`elem: `, elem, `\nid: ${id} \noffset: ${offset}`);

    if (elem) {
        elem.scrollTo({top: offset, behavior: "smooth"});
    }

    return null;
}

export const killCopy = () => {
    return false;
}

export const reEnable = () => {
    return true;
}

export const preventCopy = () => {

    return false;
    if (isElectron || isBrowser) {
        document.onselectstart = new Function ("return false")

        if (window.sidebar) {
            document.onmousedown = killCopy
            document.onclick = reEnable
        }
    } else {
        return false;
    } 
}

export const masterHandleClose = (target, r, a, t, id) => {
    if (typeof id === 'undefined') {id = 1} 
    if (typeof t === 'undefined') { t = 'sasp-hideDaily'}

    let elem = document.getElementById(target);
    elem.classList.remove(r);
    localStorage.setItem(t, id);

    if (typeof a !== 'undefined') {
        elem.classList.add(a);
    }

    return null;
}

export const addClass = (target, classarr) => {
    let elem = document.getElementById(target);

    for (const item of classarr) {
        try {
            elem.classList.add(item);
        } catch (e) {
        }
        
    }

    return null;
}

export const removeClass = (target, classarr) => {
    let elem = document.getElementById(target);

    for (const item of classarr) {
        elem.classList.remove(item);
    }

    return null;
}

export const clearStorage = (item) => {
    if (typeof item !== 'undefined' && getLocalStorage(item) !== null) {
        localStorage.removeItem(item);
    } else if (item === 'org.auanet.auau.sasp') {
        // localStorage.clear();
        clearLocalStorage();
        localStorage.removeItem('sasp_user_details');
        localStorage.removeItem('login_dt');
        localStorage.removeItem('auth_feedback');
    }

    return null;
}

export const getThisYear = () => {
    let _d = new Date();
    let _y = _d.getFullYear();

    return _y;
}

export const checkDailyEpoch = (target, interval) => {
    if (typeof target === 'undefined') { target = 'sasp-dailyEpoch'; }
    if (typeof interval === 'undefined') { interval = 1; }

    if (getLocalStorage(target) === null) { 
        let d = Date.now();

        localStorage.setItem(target, d);
        return true;
    } else {
        let d = Date.now();

        let p = Number(getLocalStorage(target));

        let _d = new Date(d);
        let _p = new Date(p);

        _d.setHours(0);
        _d.setMinutes(0);
        _d.setSeconds(0);
        _d.setMilliseconds(0);

        _p.setHours(0);
        _p.setMinutes(0);
        _p.setSeconds(0);
        _p.setMilliseconds(0);

        let diff = (_d - _p);
        diff = Math.ceil(Math.abs((_d - _p) / 1000 * 60 * 60 * 24));

        if (diff >= interval || getLocalStorage(target) === null) {
            localStorage.setItem(target, d);
            return true;
        } else {
            return false;
        }
    }
}

export const getLoadingPhrases = (int) => {
    const str = [
        'Checking Authorization...',
        'Making Database Connection...',
        'Verifying Access...',
        'Accessing Resident Results...',
        'Loading Results (resident)...',
        'Loading Results (peer group)...',
        'Loading Results (user)...',
        'Calculating Rankings...',
        'Syncing Data...',
        'Finalizing Setup...',
    ];

    if (int < 10) {
        return str[int];
    }

    return str[9];
}

export const alertDismissed = (func) => {
    func();
    return null;
}

export const alertNotification = (obj) => {
    if (navigator.notification) {
        let func = () => {

        }
        if (typeof obj.callback === 'function') { func = obj.callback; }
        switch (obj.type) {
            default: {
                navigator.notification.alert(
                    obj.message,            // message
                    alertDismissed(func),         // callback
                    obj.title,              // title
                    obj.buttonName          // buttonName
                );
            }
        }
    }

    return null;
}

export const createMarkup = props => {
    return { __html: props };
};

export const reloadPage = (bool) => {
    
    return window.location.reload(bool);;
};

export const setColorObj = (type) => {
    let r;

    switch (type) {
        default: {
            r = {
                deck: "neutralGreenCard",
                text: "neutralGreenText",
                button: "neutralGreenCard"
            }
        }
    }
    return r;
};

export const removeJSONProp = (obj, prop) => {    
    let newobj = obj;
    delete newobj[prop];

    return newobj;
}

export const getDayOfYear = () => {
    const date = DATE;
    const startOfYear = new Date(APPYEAR, 0, 0);
    const diff = date - startOfYear;
    const oneDay = 1000 * 60 * 60 * 24;
    const dayOfYear = Math.floor(diff / oneDay);
    
    return dayOfYear;
}

export const getQuizTestType = (obj) => {
    let prefix = '';
    if (obj.isquiz) {
        prefix = `sasp_my_quizzes`;
    } else {
        prefix = `sasp_my_cme_tests`
    }

    const ls = getLocalStorage(`${prefix}`);

    return ls

}

export const randomtext = () => {
    const arr = [
        'Requesting Data',
        'Gathering Data',
        'Generating Quiz',
        'Each Quiz is generated by up to 10 random questions form the Question Bank',
        'Each Quiz is generated by up to 10 random questions form the Question Bank',
        'Compiling Data',
        'Almost Ready',
        'Good Luck',
        'Good Luck',
        'Good Luck'
    ];

    let cnt = 0;

    let resp = setTimeout(() => {
        return arr[cnt % 10]
    }, 2000, cnt);

    return resp;
}

export function bytesToMB(bytes) {
    return (bytes / (1024 * 1024)).toFixed(2);
}

export function getLocalStorageSize() {
    let total = 0;
    for (let key in localStorage) {
        try {
            if (localStorage.hasOwnProperty(key) && localStorage[key] !== null) {
                total += (localStorage[key].length * 2); // 2 bytes per character
            }
        } catch (e) {
        }
    }

    localStorage.setItem(`sasp_storage_size`, total);
    return total;
}

export function getLocalStorage (key, location) {
    try {
        let str = localStorage.getItem(key);

        if (str !== null && str.startsWith(`__sasp__`)) {
            str = str.slice(8);
            str = LZString.decompress(str);
        }

        return str;
    } catch (e) {}
}

export function setActiveNavigationWidget (target) {
    document.getElementsByClassName("footer")[0].querySelectorAll(".MuiBottomNavigationAction-root").forEach(el => {
        el.classList.remove("Mui-selected");
        el.classList.remove("active");
    });
    document.getElementById(target).classList.add("Mui-selected");
    document.getElementById(target).classList.add("active");

    return null;
}

export function setLocalStorage (key, value) {
    try {
        localStorage.setItem(key, `__sasp__${LZString.compress(value)}`);
    } catch (e) {
        if (e instanceof DOMException && (e.code === 22 || e.code === 1014)) {

            for (let item in localStorage) {
                if (localStorage.hasOwnProperty(item)) {
                }
            }

            getLocalStorageSize();

            // Handle storage issues here
        }
    }

    return null;
}